import styled from 'styled-components';

export const Container = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.gray[400]};
  border-radius: 8px;

  background-color: ${({ theme }) => theme.colors.white};

  display: flex;
  align-items: center;
  gap: 16px;

  padding: 0 16px;

  width: 100%;

  transition: border-color 0.2s, box-shadow 0.2s;

  &:focus-within {
    border-color: ${({ theme }) => theme.colors.orange.primary};
    box-shadow: 0 0 0 3px rgba(245, 128, 37, 0.15);
  }

  input {
    padding: 12px 0;
    width: 100%;
    background: none;
    border: none;
    outline: none;
  }

  span {
    display: flex;
    align-items: center;
  }
`;
